// extracted by mini-css-extract-plugin
var _1 = "DocFlowCommunicationStatusCell-modulecell__F2isr TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "cell" }
